<template>
  <v-btn
    v-if='!ssmUrl'
    @click="runCommand"
    :loading="loading"
    text
  >
    <v-icon size="25" color="red dark-2">mdi-reload</v-icon>
    Retry Failed Jobs
  </v-btn>
  <v-btn v-else
    @click="clipboard"
    text
  >
    <v-icon size="25" color="green dark-2">mdi-clipboard-outline</v-icon>
    Copy SSM Url to Clipboard
  </v-btn>
</template>
<script>
export default {
  props: {
    client: { required: true },
  },
  data: () => (
    {
      loading: false,
      ssmUrl: ''
    }
  ),
  methods: {
    runCommand() {
        this.loading = true;
        this.$http.post(`api/v1/infra/aws/${this.client.id}/ssm/run_command/retry_failed_jobs`, {})
          .then((response) => {
            this.ssmUrl = response.url
            window.Notify.success(this.ssmUrl);
          })
          .catch(error => {
            this.showResponseError(error);
          })
          .finally(() => (this.loading = false));
    },
    clipboard() {
      navigator.clipboard.writeText(this.ssmUrl);
      window.Notify.success('Copied to clipboard.');
      this.ssmUrl = null
    }
  },
};
</script>
